module.exports = __webpack_public_path__ + "static/media/6.142dde09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/instagram/6.jpg
// module id = 556
// module chunks = 0